import { useState, useEffect } from 'react';
import {useBaseApi} from "../useBaseApi";

export function useSectors() {

    const [sectors, setSectors] = useState();
    const {get} = useBaseApi();

    useEffect( () => {
        load();
    }, []);

    const load = async () => {
        let response = await get("/sector", false);
        setSectors(response.data);
    }

    return [sectors];
}